var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "#0E72ED",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.70709V13.5C10.5 13.7761 10.2761 14 10 14C9.72388 14 9.5 13.7761 9.5 13.5V7.70709L7.35352 9.85358C7.1582 10.0488 6.8418 10.0488 6.64648 9.85358C6.45117 9.65826 6.45117 9.34174 6.64648 9.14642L9.64648 6.14642C9.8418 5.95117 10.1582 5.95117 10.3535 6.14642L13.3535 9.14642C13.5488 9.34174 13.5488 9.65826 13.3535 9.85358C13.1582 10.0488 12.8418 10.0488 12.6465 9.85358L10.5 7.70709Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatUpload);
export default __webpack_public_path__ + "static/media/icon-chat-upload.a3244cb07bf1a82763ce96155369c1a1.svg";
export { ForwardRef as ReactComponent };